import { Flex, Heading, Link, Text as ChakraText } from '@chakra-ui/layout'
import { Button, Icon } from '@chakra-ui/react'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { MdOutlinePolicy } from 'react-icons/md'
import { NavLink, useRouteMatch } from 'react-router-dom'
import { colors } from '../../../ui-kit'
import { PermissionsEnum } from '../../../utils'
import PermissionGuard from '../../components/PermissionGuard'

const HomeLayout = (): React.ReactElement => {
  const { path } = useRouteMatch()
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PermissionsEnum.SELF_MEDIA_LIBRARY_MANAGE}>
      {(hasPermission: boolean) => (
        <Flex
          flexDirection="column"
          textAlign="center"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          width="100%"
          p={10}
        >
          <Icon as={MdOutlinePolicy} h={56} w={56} color="appClearBlue" />
          <Heading as="h6" size="md" fontWeight="600" marginBottom="1em">
            {hasPermission
              ? t('create_a_new_path_policy', 'Create a new path policy')
              : t('path_policy', 'Path policy')}
          </Heading>

          <ChakraText
            color={colors.appBattleshipGrey}
            fontWeight="500"
            fontSize="1em"
            maxW={96}
            margin="0 auto"
          >
            {t(
              'path_policy_info',
              'Configure path policy to control custom metadata, uploads and media library API operations.',
            )}
            <br />
            <Trans t={t} i18nKey="learn_more_from_the_docs">
              <Link
                fontSize="1em"
                isExternal
                href="https://imagekit.io/docs/dam/path-policy"
              >
                Learn more
              </Link>{' '}
              from the docs.
            </Trans>
          </ChakraText>
          {hasPermission ? (
            <Link
              as={NavLink}
              position="relative"
              display="flex"
              alignItems="center"
              to={`${path}/new`}
              margin="0 auto"
              marginTop="1em"
              _hover={{ textDecoration: 'none', outline: 'none' }}
            >
              <Button>+{t('add_new')}</Button>
            </Link>
          ) : null}
        </Flex>
      )}
    </PermissionGuard>
  )
}

export default HomeLayout
